<template>
    <span class="admin-vue-kit__status" :class="`admin-vue-kit__status--${variant}`">{{ label }}</span>
</template>

<script>
export default {
    name: 'AdminStatusPill',
    props: {
        label: { type: String, required: true },
        variant: { type: String, default: 'chiusa' },
    },
};
</script>
